module.exports = __webpack_public_path__ + "img/bancoestado_extractor.9589a342.png";